module.exports = __webpack_public_path__ + "static/media/Gilroy-Black-Italic.432190e3.eot";